import { useCallback, useMemo } from "react";

import { useLocalStorage } from "usehooks-ts";

import { createFNVHashSync } from "../../../components/authentication/utils";

export type LiveLedgerSettingsState = {
  includeInternalTransfers: boolean;
};

export const DEFAULT_LIVE_LEDGER_SETTINGS: LiveLedgerSettingsState = {
  includeInternalTransfers: false,
};

const PLACEHOLDER_KEY = "live_ledger_settings__anonymous";

export const getLiveLedgerSettingsKey = (userId: string): string => {
  const hashedId = createFNVHashSync(userId);
  return `live_ledger_settings_${hashedId}`;
};

export const useLiveLedgerSettings = (userId: string | undefined) => {
  const storageKey = useMemo(
    () => (userId ? getLiveLedgerSettingsKey(userId) : PLACEHOLDER_KEY),
    [userId]
  );

  const [state, setStateRaw] = useLocalStorage<LiveLedgerSettingsState>(
    storageKey,
    DEFAULT_LIVE_LEDGER_SETTINGS
  );

  const setState = useCallback(
    (value: LiveLedgerSettingsState) => {
      if (userId) setStateRaw(value);
    },
    [userId, setStateRaw]
  );

  return [userId ? state : DEFAULT_LIVE_LEDGER_SETTINGS, setState] as const;
};
